import _axios, { isolatedAxios } from "../api";

export const getActionItemList = async (qryparam) => {
  const response = await _axios.get(`/actiondetail/list/`, {
    params: qryparam
  });
  return response.data;
};

export const addActionItem = async (actionDetailItemModel) =>
  await _axios
    .post(`/ActionDetail/create`, JSON.stringify(actionDetailItemModel))
    .then((response) => {
      return response.data;
    });

export const getActionitemById = async (id) =>
  await _axios.get(`/actiondetail/edit/${id}`).then((response) => {
    return response.data;
  });

export const updateActionItem = async (actionDetailItemModel) =>
  await _axios
    .post(`/actiondetail/update`, JSON.stringify(actionDetailItemModel))
    .then((response) => {
      return response.data;
    });

export const deleteActionItem = async (id) =>
  await _axios.post(`/actiondetail/delete/${id}`).then((response) => {
    return response.data;
  });

export const uploadActionItemFiles = async (actionItemFileModel) =>
  await _axios.post(`/action/file`, JSON.stringify(actionItemFileModel)).then((response) => {
    return response.data;
  });

export const getFiles = async (id) => {
  return await _axios
    .get(`/action/getFiles`, {
      params: { actionDetailItemId: id }
    })
    .then((response) => response.data);
};

export const deleteFile = async (id) =>
  await isolatedAxios.post(`/files/remove/${id}`).then((response) => {
    return response.data;
  });
export const downloadActionItemDocument = async (id, caseManagerDetailId) => {
  const res = await _axios.get(`actiondetail/document-download`, {
    params: { actionDiaryMasterDocumentId: id, caseManagerDetailId: caseManagerDetailId },
    responseType: "blob"
  });
  const cd = res.headers["content-disposition"] || "";
  const filenameMatch = cd.match(/filename\*=UTF-8''(.+)|filename="?([^";]+)"?/);
  const filename = filenameMatch
    ? decodeURIComponent(filenameMatch[1] || filenameMatch[2])
    : "document.docx";

  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
